import React from 'react'
import { SiteContainer, Main, Flex, FlexItem, Wrapper } from 'core/layout'

import { Heading, Card, Hairline, Anchor, GoogleMap, Button, BreadcrumbsConnected } from 'elements'
import { RawContent } from 'elements/util'
import { Link } from 'react-router-dom'
import tulkojumi from 'utils/tulkojumi';
import {  StyledContent,StyledContentP, Small, StyledTop, Form, Label, InputContainer, Atsauce } from './styled';



class Kontakti extends React.PureComponent {

  render() {

    const props = this.props

    let acf = {}
    let teksti = {}

    if (props.content.acf) {
      acf = JSON.parse(props.content.acf)
    }

    if (props.teksti) {
      teksti = props.teksti
    }


    return (<SiteContainer>

              <BreadcrumbsConnected
                lang={props.lang}
                path={props.init_page.path}
              />

              <Wrapper>

                <Flex>
                  <Main>
                    <Heading>
                      { props.init_page.title }
                    </Heading>
                    <StyledTop>
                      <Flex wrap="true">
                        { acf.kontakti ? acf.kontakti.map((kontakts, index) =>
                        (<FlexItem basis={1/2} width="50%" key={ index }>
                          <Heading level={ 3 }>
                            <Anchor href={ kontakts.value.replace(/\s/g, '').indexOf('@') > 0 ? `mailto:${kontakts.value.replace(/\s/g,'')}` : `tel:${kontakts.value.replace(/\s/g,'')}` }>
                              { kontakts.value }
                            </Anchor>
                          </Heading>
                          <Small>
                            { kontakts.nosaukums }
                          </Small>
                        </FlexItem>)) : null }
                      </Flex>
                    </StyledTop>
                    <Flex column>
                      { props.content.relationship_pages ? props.content.relationship_pages.map((post, index) =>
                        (<FlexItem key={ index }>
                          <Card type="link" title={ post.title } link={ post.path } />
                        </FlexItem>)) : null }
                    </Flex>
                  </Main>
                </Flex>

                <Hairline main="true" />

                <StyledContent>
                  <Heading level={ 3 }>
                    { acf.subtitle }
                  </Heading>
                  <Flex>
                        <FlexItem basis={3/12}>
                          <RawContent content={ props.content.content } />
                        </FlexItem>
                        <FlexItem basis={5/12}>
                          <GoogleMap zoom={16} width="100%" height="100%" coordinates={acf.map} />
                        </FlexItem>
                  </Flex>
                </StyledContent>

                <Hairline main="true" />

<StyledContent width={8/12}>
  <Heading level={ 3 }>
  {tulkojumi(teksti, 'sazinas_forma')}
  </Heading>
  <StyledContentP width={7/8}>
    {tulkojumi(teksti, 'sazinas_forma_apraksts')}
  </StyledContentP>
</StyledContent>

<Form width={8/12} >
  <Flex wrap="true" >


      <FlexItem basis={4/8} >
        <Label >
          <span>
            {tulkojumi(teksti, 'vards')}*
          </span>
        </Label>
        <input
          tabIndex={0}
          placeholder='Jānis'
          aria-label={tulkojumi(teksti, 'vards')}
        />
      </FlexItem>


      <FlexItem basis={4/8} >
        <Label >
          <span>
            {tulkojumi(teksti, 'uzvards')}*
          </span>
        </Label>
        <input
          tabIndex={1}
          placeholder='Bērziņš'
          aria-label={tulkojumi(teksti, 'uzvards')}
        />
      </FlexItem>



      <FlexItem basis={4/8} >
        <Label >
          <span>
            {tulkojumi(teksti, 'tavs_e_pasts')}*
          </span>
        </Label>
        <input
          tabIndex={2}
          placeholder='janis.berzins@mail.lv'
          aria-label={tulkojumi(teksti, 'tavs_e_pasts')}
        />
      </FlexItem>


      <FlexItem basis={4/8} >
        <Label >
          <span>
            {tulkojumi(teksti, 'talrunis')}
          </span>
        </Label>
        <input
          tabIndex={3}
          placeholder='2999990'
          aria-label={tulkojumi(teksti, 'talrunis')}
        />
      </FlexItem>


      <FlexItem basis={8/8} >
        <Label >
          <span>
            {tulkojumi(teksti, 'zina')}
          </span>
        </Label>
        <textarea  placeholder={tulkojumi(teksti, 'tava_zina')} />
        <Atsauce>
          *{tulkojumi(teksti, 'obligatie_lauki')}<br/>
          {tulkojumi(teksti, 'jus_varat_pievienot_failu_sados_formatos')}
        </Atsauce>
      </FlexItem>


      <FlexItem basis={4/8} >
       <Button a11yLabel={tulkojumi(teksti, 'pievienot_failu')} type='outlined' typeAttr='button'>{tulkojumi(teksti, 'pievienot_failu')}</Button>
      </FlexItem>

      <FlexItem basis={4/8} >
       <Button a11yLabel={tulkojumi(teksti, 'nosutit')} accent='secondary' type='standard' typeAttr='submit' >{tulkojumi(teksti, 'nosutit')}</Button>
      </FlexItem>


    </Flex>
</Form>



              </Wrapper>









            </SiteContainer>)


  }
}

export default Kontakti



// WEBPACK FOOTER //
// ./src/pages/PasvaldibasKontakti/PasvaldibasKontakti.jsx